import React from "react"
import cx from "classnames"

import styles from "./styles.module.scss"
import { Link } from "gatsby"

interface GridItem {
	title: string
	text: string
	image: {
		src:  string
		width: number
		height: number
	}
	link: string
}

interface Props {
	items: GridItem[]
}
const Grid: React.FC<Props> = ({items}) => {
  return (
    <div className={cx(styles.GridContainer)}>
      <div className={cx(styles.Grid)}>
        {items.map((item, idx) => {
          return (
            <div className={cx(styles.GridItem)} key={idx}>
              <Link to={`/${item.link}`}>
                <img src={item.image.src} alt={item.title} title={item.title} />
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </Link>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Grid